module.exports = __webpack_public_path__ + "static/media/3_kosh_a.f300d35d.ogg";